<template>
  <label class="anz-fc-checkbox">
    <input
      type="checkbox"
      v-model="modelValue"
      @change="$emit('update:modelValue', modelValue)"
    />
    <span class="anz-fc-check-icon"></span>
    <span class="anz-fc-check-text"
      ><slot name="title">{{ title }}</slot></span
    >
  </label>
</template>

<script lang="ts">
export default {
  name: 'ACheckbox',
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },
}
</script>
